import React, { useState, useEffect } from 'react';
import PropTypes from "prop-types";
import productsStore from 'stores/new/Products';
import Shelf from "components/Shelf";

const ShelfContainer = (props) => {

    const [products, setProducts] = useState([]);
    const { store }  = props;

    useEffect(() => {
        let prods = (store && store.products) ? store.products.get('shelf') : null;

        if(prods && prods.toList){
            prods = prods.toList().toArray();
            setProducts(prods);
        }else{
            setProducts([]);
        }
    },[store])

    return <Shelf {...props} products={products} />
}

ShelfContainer.propTypes = {
    title: PropTypes.string,
    changeQuantity: PropTypes.func,
    filter: PropTypes.object,
    categories: PropTypes.array,
    store: PropTypes.object
};

export default productsStore.wrapConsumer(ShelfContainer);